<template>
  <div :class="'main-'+theme">
    <card :class="'main-'+theme">
      <h4
        class="card-title text-center"
        :class="'title-'+theme"
      >Catalogador de Velas & Ciclos da Teoria Cutrim</h4>
      <hr />
      <!-- CATA-CANDLE SYSTEM -->
      <card class="col-md-12 col-lg-12" :class="'card-catalog-'+theme">
        <div class="row card-boby justify-content-center">
          <div class="col-md-6">
            <card class="stacked-form" :class="'card-catalog-'+theme">
              <form @submit.prevent="onSubmitForm">
                <div>
                  <h4 class="card-title">
                    <small>Preencha todos os campos abaixo:</small>
                  </h4>
                  <hr />
                  <div class="row">
                    <div class="col-md-6">
                      <label>Ativo:</label>
                      <br />
                      <el-select
                        class="col-md-12 select-"
                        :class="theme === 'black' ? 'azure' : 'primary'"
                        size="large"
                        tabindex="1"
                        placeholder="Selecione aqui..."
                        v-model="selectedAsset"
                      >
                        <el-option
                          v-for="option in selects.assets"
                          class="col-md-12 select-"
                          :class="theme === 'black' ? 'azure' : 'primary'"
                          :value="option.value"
                          :label="option.label"
                          :key="option.label"
                        ></el-option>
                      </el-select>
                    </div>
                    <div class="col-md-6">
                      <label>QTD. Inicial de Velas:</label>
                      <br />
                      <fg-input
                        type="number"
                        tabindex="2"
                        v-model="howManyCandles"
                        placeholder="120 (Recomendado)"
                      ></fg-input>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <label>Período:</label>
                      <br />
                      <el-select
                        class="col-md-12 select-"
                        :class="theme === 'black' ? 'azure' : 'primary'"
                        size="large"
                        tabindex="3"
                        placeholder="Selecione aqui..."
                        v-model="selectedCandleTime"
                      >
                        <el-option
                          v-for="option in selects.candleTimes"
                          class="col-md-12 select-"
                          :class="theme === 'black' ? 'azure' : 'primary'"
                          :value="option.value"
                          :label="option.label"
                          :key="option.label"
                        ></el-option>
                      </el-select>
                    </div>
                    <div class="col-md-6">
                      <label>Horário Inicial (Catalogação):</label>
                      <br />
                      <fg-input type="time" tabindex="4" v-model="initCatalogTime"></fg-input>
                    </div>
                  </div>
                  <br />
                  <input
                    type="submit"
                    class="btn btn-fill"
                    :class=" theme === 'black' ? 'btn-azure2':'btn-primary' "
                    value="Catalogar"
                  />
                </div>
              </form>
            </card>
          </div>
        </div>
        <hr />
        <div class="card-footer text-right">
          <h4 class="card-title">
            <small>
              *Esta ferramenta é destinada à catalogação de velas e ciclos da Teoria Cutrim.
              <br />*O uso do conhecimento gerado pela mesma é de sua inteira responsabilidade.
            </small>
          </h4>
        </div>
      </card>

      <div class="row col-md-12">
        <div class="row col-md-6 col-sm-12">
          <h5 class="col-md-6 col-sm-12">Ativo: {{selectedAsset}}</h5>
          <h5 class="col-md-6 col-sm-12">Qtd. de Velas: {{this.candles.length}}</h5>
        </div>
        <div class="row col-md-6 col-sm-12">
          <h5 class="col-md-6 col-sm-12">Período: {{selectedCandleTime}}</h5>
          <h5 class="col-md-6 col-sm-12">Horário Inicial: {{initCatalogTime}}</h5>
        </div>
      </div>
    </card>
    <div class="row col-md-12 col-sm-12">
      <div class="col-md-4">
        <h4 class="card-title">
          <small :class="'title-'+theme">Parametrização Teoria Cutrim:</small>
        </h4>
        <card class="stacked-form" :class="'card-catalog-'+theme">
          <form method="#" action="#" @submit.prevent>
            <div>
              <el-select
                multiple
                class="select-primary col-md-12"
                size="large"
                v-model="selects.selectedCycles"
                placeholder="Selecione Ciclo(s) aqui..."
              >
                <el-option
                  v-for="option in selects.cycles"
                  class="select-primary"
                  :value="option"
                  :label="option.label"
                  :key="option.label"
                ></el-option>
              </el-select>
            </div>
            <div>
              <el-select
                multiple
                class="select-primary col-md-12"
                size="large"
                v-model="selects.selectedStrategies"
                placeholder="Selecione Cenário Macro aqui..."
              >
                <el-option
                  v-for="option in selects.strategies"
                  class="select-primary"
                  :value="option.value"
                  :label="option.label"
                  :key="option.label"
                ></el-option>
              </el-select>
            </div>
            <hr />
            <div class="text-center">
              <button
                type="submit"
                :disabled="howManyCandles<=0"
                @click="updateCandleCyles()"
                class="btn btn-round btn-fill"
                :class=" theme === 'black' ? 'btn-azure2':'btn-primary' "
              >
                <i class="nc-icon nc-refresh-02"></i> Atualizar
              </button>
            </div>
          </form>
        </card>
      </div>
      <div class="col-md-8 col-sm-12">
        <h4 class="card-title">
          <small :class="'title-'+theme">Catalagoção Velas por Cor:</small>
        </h4>
        <card :class="'card-catalog-'+theme">
          <div class="card-header">
            <h4 class="card-title">
              <button
                class="btn btn-round btn-fill"
                :class=" theme === 'black' ? 'btn-azure2':'btn-primary' "
                @click.prevent="openModal('commands')"
              >
                <i class="nc-icon nc-controller-modern"></i> Comandos
              </button>
              <div align="right">
                Total:
                <button class="btn btn-green"></button>
                -
                {{ candlesColor['green'] ? candlesColor['green'].length : 0 }}
                |
                <button
                  class="btn btn-red"
                ></button>
                -
                {{ candlesColor['red'] ? candlesColor['red'].length : 0 }}
              </div>
            </h4>
          </div>
          <el-dialog center title :visible.sync="modals.commands">
            <span>
              <card>
                <h4 class="card-title text-center">Como selecionar Velas por Cor ?</h4>
                <br />
                <div class="card-body">
                  <h5>
                    <strong>Clique ou Avance via tecla Tab</strong> sobre cada
                    <strong>Caixa de Seleção de Vela</strong>, utilizando
                    um dos seguintes comandos:
                  </h5>
                  <div class="col-md-12">
                    <h4 class="card-title">
                      <small>Via Mouse:</small>
                    </h4>
                    <hr />
                    <ul class="col-md-12">
                      <li>
                        <h5>
                          <strong>Vela Doji:</strong>
                          Botão
                          <strong>Central</strong> do Mouse (quando existente).
                        </h5>
                      </li>
                      <li>
                        <h5>
                          <strong>Vela Vermelha:</strong>
                          Botão
                          <strong>Direito</strong> do Mouse.
                        </h5>
                      </li>
                      <li>
                        <h5>
                          <strong>Vela Verde:</strong>
                          Botão
                          <strong>Esquerdo</strong> do Mouse.
                        </h5>
                      </li>
                    </ul>
                  </div>
                  <br />
                  <div class="col-md-12">
                    <h4 class="card-title">
                      <small>Via Teclado:</small>
                    </h4>
                    <hr />
                    <ul class="col-md-12">
                      <li>
                        <h5>
                          <strong>Vela Doji:</strong>
                          Tecla
                          <strong>1</strong> do Teclado ou Numpad.
                        </h5>
                      </li>
                      <li>
                        <h5>
                          <strong>Vela Vermelha:</strong>
                          Tecla
                          <strong>2</strong> do Teclado ou Numpad.
                        </h5>
                      </li>
                      <li>
                        <h5>
                          <strong>Vela Verde:</strong>
                          Tecla
                          <strong>3</strong> do Teclado ou Numpad.
                        </h5>
                      </li>
                    </ul>
                  </div>
                </div>
              </card>
            </span>
          </el-dialog>
          <ul id="candles" class="card-body col-lg-12 col-md-12 col-sm-12">
            <li
              v-for="(candle, index) in candles"
              :key="index"
              v-on:mousedown.left="selectCandleColor('green', index)"
              v-on:mousedown.middle="selectCandleColor('doji', index)"
              v-on:mousedown.right="selectCandleColor('red', index)"
              v-on:keyup.49="selectCandleColor('doji', index)"
              v-on:keyup.50="selectCandleColor('red', index)"
              v-on:keyup.51="selectCandleColor('green', index)"
              v-on:keyup.97="selectCandleColor('doji', index)"
              v-on:keyup.98="selectCandleColor('red', index)"
              v-on:keyup.99="selectCandleColor('green', index)"
              v-on:contextmenu.prevent
            >
              <el-select
                :class="'select-' + candle.color"
                :title="'Horário: ' + candle.time"
                :tabindex="index"
                size="small"
                v-model="selectedCandleColor"
                v-on:change="selectCandleColor(selectedCandleColor, index)"
              >
                <el-option
                  v-for="option in selects.candles"
                  :class="'select-' + option.value"
                  :value="option.value"
                  :label="candle.time"
                  :key="option.label"
                ></el-option>
              </el-select>
            </li>
            <li key="plus">
              <button
                class="btn btn-social btn-round"
                :class=" theme === 'black' ? 'btn-azure2':'btn-primary' "
                @click="addCandle()"
              >
                <i class="fa fa-plus"></i>
              </button>
            </li>
          </ul>
        </card>
      </div>
    </div>
    <hr />
    <div class="col-md-12">
      <div class="col-md-12">
        <h4 class="card-title">
          <small :class="'title-'+theme">Formação Cíclica:</small>
        </h4>
        <card :class="'card-catalog-'+theme">
          <h4 align="right" :class="'header-'+theme">
            Total:
            <button class="btn btn-blue"></button>
            -
            {{ cyclesColor['Ciclo Azul'] ? cyclesColor['Ciclo Azul'].length : 0 }}
            |
            <button
              class="btn btn-pink"
            ></button>
            -
            {{ cyclesColor['Ciclo Rosa'] ? cyclesColor['Ciclo Rosa'].length : 0 }}
            <button
              class="btn btn-green"
            ></button>
            -
            {{ cyclesColor['Ciclo Verde'] ? cyclesColor['Ciclo Verde'].length : 0 }}
            <button
              class="btn btn-warning"
            ></button>
            -
            {{ cyclesColor['Ciclo Laranja'] ? cyclesColor['Ciclo Laranja'].length : 0 }}
          </h4>
          <ul id="cycles" class="card-body col-lg-12 col-md-12 col-sm-12">
            <li v-for="(cycle, index) in cycles" :key="index" v-if="cycle.label !== 'neutral'">
              <button
                type="button"
                :title="'Fechamento: ' + cycle.time"
                :class="'btn btn-sm btn-' + objectColor[cycle.label]"
              >
                <strong>{{ cycle.label + ' às ' + cycle.time }}</strong>
              </button>
            </li>
          </ul>
        </card>
      </div>
      <br />
      <div class="col-md-12">
        <card
          :class="'card-catalog-'+theme"
          v-if="selects.selectedStrategies.includes('triplication')&&selects.selectedCycles.length"
        >
          <h5 class="card-title text-center">Cenário Macro da Triplicação</h5>
          <br />
          <div class="row col-md-12">
            <div class="col-md-6 col-sm-12">
              <card :class="'card-catalog-'+theme">
                <h4 class="card-title">
                  <small :class="'header-'+theme">Triplicações:</small>
                  <h5 class="pull-right">
                    <small>
                      Legenda:
                      <br />
                      <i class="nc-icon nc-check-2 btn-success"></i> - Triplicação |
                      <i class="nc-icon nc-simple-remove btn-danger"></i> - Não-Triplicação
                    </small>
                  </h5>
                </h4>
                <hr />
                <ul id="triplication" class="col-lg-12 col-md-12 col-sm-12">
                  <li v-for="(triplication, index) in triplications" :key="index">
                    <button
                      type="button"
                      :title="triplication.type"
                      :class="'btn btn-sm btn-' + (triplication.type === 'Triplicação' ? 'success' : 'danger')"
                    >
                      <strong>
                        <i class="nc-icon nc-check-2" v-if="triplication.type === 'Triplicação'"></i>
                        <i
                          class="nc-icon nc-simple-remove"
                          v-if="triplication.type !== 'Triplicação'"
                        ></i>
                        {{ ' às ' + triplication.time }}
                      </strong>
                    </button>
                  </li>
                </ul>
              </card>
            </div>
            <table class="table col-md-6 col-sm-12" :class="'header-'+theme">
              <tr>
                <th>Triplicação (%)</th>
                <th>Não-Triplicação (%)</th>
              </tr>
              <tr>
                <td>
                  {{
                  triplicationPercentage
                  }} %
                </td>
                <td>
                  {{
                  nonTriplicationPercentage
                  }} %
                </td>
              </tr>
            </table>
          </div>
        </card>
      </div>
    </div>
    <div class="copyright text-right" :class="'footer-'+theme">
      &copy; TopTrader 2019. Feito com
      <i class="fa fa-heart heart"></i> pela equipe TopDev.
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { Select, Option, Dialog } from "element-ui";
import _ from "lodash";
import {
  Card,
  Switch as LSwitch,
  FormGroupInput as FgInput
} from "src/components/index";

export default {
  name: "cataloging-tool",
  components: {
    FgInput,
    Card,
    LSwitch,
    [Select.name]: Select,
    [Option.name]: Option,
    [Dialog.name]: Dialog
  },
  props: {},
  data() {
    return {
      modals: {
        commands: false
      },
      howManyCandles: 120,
      selectedAsset: "EURUSD",
      selectedCandleTime: "1 minute",
      initCatalogTime: "00:00",
      selectedCandleColor: "",
      candles: [{}],
      triplications: [{}],
      maxContinuousTriplication: 0,
      maxAlternatesTriplication: 0,
      maxNonTriplication: 0,
      triplicationPercentage: 0,
      nonTriplicationPercentage: 0,
      candlesColor: {},
      cyclesColor: {},
      cycleType: {
        "Ciclo Azul": "Triplicação",
        "Ciclo Rosa": "Não Triplicação",
        "Ciclo Verde": "Triplicação",
        "Ciclo Laranja": "Não Triplicação"
      },
      objectColor: {
        "Ciclo Azul": "blue",
        "Ciclo Rosa": "pink",
        "Ciclo Verde": "green",
        "Ciclo Laranja": "warning"
      },
      cycles: [],
      selects: {
        assets: [
          { value: "EUR/USD", label: "EUR/USD" },
          { value: "EUR/JPY", label: "EUR/JPY" },
          { value: "USD/CAD", label: "USD/CAD" },
          { value: "USD/JPY", label: "USD/JPY" },
          { value: "AUD/USD", label: "AUD/USD" },
          { value: "GBP/USD", label: "GBP/USD" }
        ],
        candleTimes: [
          { value: "1 minute", label: "1 minuto" },
          { value: "5 minutes", label: "5 minutos" },
          { value: "15 minutes", label: "15 minutos" },
          { value: "1 hour", label: "1 hora" }
        ],
        candles: [
          { value: "green", label: "Verde" },
          { value: "red", label: "Vermelha" },
          { value: "doji", label: "Doji" }
        ],
        selectedCycles: [],
        cycles: [
          { value: "blue", label: "Ciclo Azul" },
          { value: "pink", label: "Ciclo Rosa" },
          { value: "orange", label: "Ciclo Laranja" },
          { value: "green", label: "Ciclo Verde" }
        ],
        selectedStrategies: "",
        strategies: [{ value: "triplication", label: "Triplicação" }]
      }
    };
  },
  mounted() {
    this.candles = [new Array(parseInt(this.howManyCandles, 10))];
    this.selects.selectedCycles = this.selects.cycles;
    this.selects.selectedStrategies = ["triplication"];
    this.cycles = [];
    this.triplications = [];
    this.generatedCandleTime();
  },
  methods: {
    openModal(name) {
      this.modals[name] = true;
    },
    generatedCandleTime() {
      for (let index = 0; index < this.howManyCandles; index++) {
        if (index === 0) {
          this.candles[index] = { color: "", time: this.initCatalogTime };
        } else {
          let candleTime = moment
            .utc(this.candles[index - 1].time, "H:mm")
            .add(
              this.selectedCandleTime.split(" ")[0],
              this.selectedCandleTime.split(" ")[1]
            )
            .format("H:mm");
          this.candles[index] = { color: "", time: candleTime };
        }
      }
    },
    onSubmitForm() {
      this.candles = [{}];
      this.generatedCandleTime();
    },
    cutrimAlgorithm() {
      if (this.candles.length >= 3) {
        this.triplications = [];
        this.cycles = [];
        this.getCycles();
        this.filterCyclesActive();
        this.cyclesColor = _.groupBy(this.cycles, "label");
        if (this.cycles.length >= 3) {
          this.getTriplications();
          this.triplications = _.filter(this.triplications, function(o) {
            return o.label !== "neutral";
          });
          this.setPercentagesTriplications();
        }
      }
    },
    selectCandleColor(color, index) {
      this.candles[index].color = color;
      this.selectedCandleColor = color;
      this.candlesColor = _.groupBy(this.candles, "color");
      this.cutrimAlgorithm();
    },
    addCandle() {
      var candleTime = moment
        .utc(this.candles[this.candles.length - 1].time, "H:mm")
        .add(
          this.selectedCandleTime.split(" ")[0],
          this.selectedCandleTime.split(" ")[1]
        )
        .format("H:mm");
      this.candles.splice(0, 1);
      this.candles.push({ color: "", time: candleTime });
      this.cutrimAlgorithm();
    },
    updateCandleCyles() {
      this.cutrimAlgorithm();
    },
    setCycle(
      value,
      label,
      initPositionFuture,
      lastPosition,
      colorFirstPosition
    ) {
      const lastCycle = _.last(this.cycles);
      if (value !== "") {
        let breakPattern = true;
        if (lastCycle !== undefined) {
          if (
            (lastCycle.value === "blue1" && colorFirstPosition === "green") ||
            (lastCycle.value === "blue2" && colorFirstPosition === "red")
          ) {
            breakPattern = false;
          }
          if (
            "Ciclo Verde" === lastCycle.label &&
            (label === "Ciclo Laranja" || label === "Ciclo Verde")
          ) {
            breakPattern = false;
          }
        }
        if (breakPattern) {
          this.cycles.push({
            value: value,
            label: label,
            type: this.cycleType[label],
            time: this.candles[lastPosition].time
          });
        } else {
          if (
            lastCycle.label === "Ciclo Azul" ||
            (lastCycle.label === "Ciclo Verde" && label === "Ciclo Laranja")
          ) {
            initPositionFuture = lastPosition - 1;
          }
        }
      }
      if (label === "neutral") {
        this.cycles.push({
          value: value,
          label: label,
          time: this.candles[lastPosition].time
        });
      }

      return initPositionFuture;
    },
    getCycle(p1, p2, p3) {
      const value =
        this.candles[p1].color +
        "|" +
        this.candles[p2].color +
        "|" +
        this.candles[p3].color;
      const response = {
        nextPosition: 0,
        value: "",
        label: "",
        firstColor: this.candles[p1].color
      };
      switch (value) {
        // Cycle Blue 1
        case "green|green|green":
          response.value = "blue1";
          response.label = "Ciclo Azul";
          response.nextPosition = p3 + 1;
          break;

        // Cycle Blue 2
        case "red|red|red":
          response.value = "blue2";
          response.label = "Ciclo Azul";
          response.nextPosition = p3 + 1;
          break;

        // Cycle Pink 1
        case "green|green|red":
          response.value = "pink1";
          response.label = "Ciclo Rosa";
          response.nextPosition = p3;
          break;

        // Cycle Pink 2
        case "red|red|green":
          response.value = "pink2";
          response.label = "Ciclo Rosa";
          response.nextPosition = p3;
          break;
        // Cycle Green 1
        case "red|green|red":
          response.value = "green1";
          response.label = "Ciclo Verde";
          response.nextPosition = p3;
          break;
        // Cycle Green 2
        case "green|red|green":
          response.value = "green2";
          response.label = "Ciclo Verde";
          response.nextPosition = p3;
          break;
        // Cycle Orange 1
        case "green|red|red":
          response.value = "orange1";
          response.label = "Ciclo Laranja";
          response.nextPosition = p2;
          break;
        // Cycle Orange 2
        case "red|green|green":
          response.value = "orange2";
          response.label = "Ciclo Laranja";
          response.nextPosition = p2;
          break;
        // No cycle
        default:
          response.value = "";
          response.label = "";
          response.nextPosition = p2;
      }
      return response;
    },
    filterCyclesActive() {
      const blueSelected =
        _.findIndex(this.selects.selectedCycles, ["value", "blue"]) !== -1;
      const pinkSelected =
        _.findIndex(this.selects.selectedCycles, ["value", "pink"]) !== -1;
      const greenSelected =
        _.findIndex(this.selects.selectedCycles, ["value", "green"]) !== -1;
      const orangeSelected =
        _.findIndex(this.selects.selectedCycles, ["value", "orange"]) !== -1;

      this.cycles = _.filter(this.cycles, function(o) {
        return o.label !== "neutral";
      });

      if (!blueSelected) {
        this.cycles = _.filter(this.cycles, function(o) {
          return o.label !== "Ciclo Azul";
        });
      }

      if (!pinkSelected) {
        this.cycles = _.filter(this.cycles, function(o) {
          return o.label !== "Ciclo Rosa";
        });
      }

      if (!greenSelected) {
        this.cycles = _.filter(this.cycles, function(o) {
          return o.label !== "Ciclo Verde";
        });
      }

      if (!orangeSelected) {
        this.cycles = _.filter(this.cycles, function(o) {
          return o.label !== "Ciclo Laranja";
        });
      }
    },
    getCycles() {
      // tranform arrays in 3 candles
      let p1 = 0;
      let p2 = p1 + 1;
      let p3 = p2 + 1;
      let newPosition = 0;
      let response = {};
      while (p3 < this.candles.length) {
        response = this.getCycle(p1, p2, p3);
        newPosition = this.setCycle(
          response.value,
          response.label,
          response.nextPosition,
          p3,
          response.firstColor
        );
        p1 = newPosition;
        p2 = p1 + 1;
        p3 = p2 + 1;
      }
    },
    setTriplication(
      value,
      label,
      initPositionFuture,
      lastPosition,
      typeFirstPosition
    ) {
      const lastTriplication = _.last(this.triplications);
      let breakPattern = true;
      if (lastTriplication !== undefined) {
        if (
          (lastTriplication.value === "blue1" &&
            typeFirstPosition === "Triplicação") ||
          (lastTriplication.value === "blue2" &&
            typeFirstPosition === "Não Triplicação")
        ) {
          breakPattern = false;
        }
        if (
          "Ciclo Verde" === lastTriplication.label &&
          (label === "Ciclo Laranja" || label === "Ciclo Verde")
        ) {
          breakPattern = false;
        }
      }
      if (breakPattern) {
        this.triplications.push({
          value: value,
          label: label,
          type: this.cycleType[label],
          time: this.cycles[lastPosition].time
        });
      } else {
        if (
          lastTriplication.label === "Ciclo Azul" ||
          (lastTriplication.label === "Ciclo Verde" &&
            label === "Ciclo Laranja")
        ) {
          initPositionFuture = lastPosition - 1;
        }
      }

      return initPositionFuture;
    },
    getTriplication(p1, p2, p3) {
      const value =
        this.cycles[p1].type +
        "|" +
        this.cycles[p2].type +
        "|" +
        this.cycles[p3].type;
      let response = {
        nextPosition: 0,
        value: "",
        label: "",
        firstType: this.cycles[p1].type
      };
      switch (value) {
        // Cycle Blue 1
        case "Triplicação|Triplicação|Triplicação":
          response.value = "blue1";
          response.label = "Ciclo Azul";
          response.nextPosition = p3 + 1;
          break;

        // Cycle Blue 2
        case "Não Triplicação|Não Triplicação|Não Triplicação":
          response.value = "blue2";
          response.label = "Ciclo Azul";
          response.nextPosition = p3 + 1;
          break;

        // Cycle Pink 1
        case "Triplicação|Triplicação|Não Triplicação":
          response.value = "pink1";
          response.label = "Ciclo Rosa";
          response.nextPosition = p3;
          break;

        // Cycle Pink 2
        case "Não Triplicação|Não Triplicação|Triplicação":
          response.value = "pink2";
          response.label = "Ciclo Rosa";
          response.nextPosition = p3;
          break;
        // Cycle Green 1
        case "Não Triplicação|Triplicação|Não Triplicação":
          response.value = "green1";
          response.label = "Ciclo Verde";
          response.nextPosition = p3;
          break;
        // Cycle Green 2
        case "Triplicação|Não Triplicação|Triplicação":
          response.value = "green2";
          response.label = "Ciclo Verde";
          response.nextPosition = p3;
          break;
        // Cycle Orange 1
        case "Triplicação|Não Triplicação|Não Triplicação":
          response.value = "orange1";
          response.label = "Ciclo Laranja";
          response.nextPosition = p2;
          break;
        // Cycle Orange 2
        case "Não Triplicação|Triplicação|Triplicação":
          response.value = "orange2";
          response.label = "Ciclo Laranja";
          response.nextPosition = p2;
          break;
        // No cycle
        default:
          response.value = "";
          response.label = "";
          response.nextPosition = p2;
      }
      return response;
    },
    getTriplications() {
      // tranform arrays in 3 candles
      let p1 = 0;
      let p2 = p1 + 1;
      let p3 = p2 + 1;
      let newPosition = 0;
      let response = {};
      while (p3 < this.cycles.length) {
        response = this.getTriplication(p1, p2, p3);
        newPosition = this.setTriplication(
          response.value,
          response.label,
          response.nextPosition,
          p3,
          response.firstType
        );
        p1 = newPosition;
        p2 = p1 + 1;
        p3 = p2 + 1;
      }
    },
    setPercentagesTriplications() {
      const totalTriplications = _.countBy(this.triplications, "type");
      if (totalTriplications["Triplicação"] !== undefined) {
        this.triplicationPercentage = parseInt(
          (totalTriplications["Triplicação"] / this.triplications.length) * 100
        );
      } else {
        this.triplicationPercentage = 0;
      }
      if (totalTriplications["Não Triplicação"] !== undefined) {
        this.nonTriplicationPercentage = parseInt(
          (totalTriplications["Não Triplicação"] / this.triplications.length) *
            100
        );
      } else {
        this.nonTriplicationPercentage = 0;
      }
    }
  },
  computed: {
    theme() {
      return this.$auth.user().layout;
    }
  }
};
</script>
<style>
.main-black {
  background: #181b1f;
  color: #fff;
}
.main-light {
  background: #d8d8d8;
}
.title-black {
  color: #fff;
}
.title-light {
  color: #03141e;
}
.header-black {
  color: #ffffff;
}
.header-light {
  color: #03141e;
}
.card-catalog-black {
  background-color: #2a2b31;
}
ul#candles li {
  float: left;
  display: inline;
  width: 8%;
}
@media (max-width: 480px) {
  ul#candles li {
    width: 40% !important;
  }
}

ul#cycles li {
  float: left;
  display: inline;
  width: 8%;
}
@media (max-width: 480px) {
  ul#cycles li {
    width: 40% !important;
  }
}

ul#triplication li {
  float: left;
  display: inline;
  width: 15.5%;
}
@media (max-width: 480px) {
  ul#triplication li {
    width: 50% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/ManualCataloging.vue